<template>
  <Modal title = "Title" v-model = "showFormModal" class-name = "card-modal" :width = "action=='view'?400:900"
         :closable = "false">
    <div slot = "header">
      <h4>{{title}}</h4>
    </div>
    <Spin size = "large" fix v-if = "spinnerShow"></Spin>
    <Form method = "post" enctype = "multipart/form-data"
          ref = "eventForm" :model = "eventForm"
          :rules = "ruleValidate"
          label-position = "top">
      <div class="widget-container">
        <Row class="my-3">
          <i-col :xs = "2" :sm = "2" :md = "2" :lg = "2">
            <FormItem label = "Deleted" :prop = "'deleted'">
              <i-switch v-model = "eventForm.deleted" @on-change = "deletedEvent"></i-switch>
            </FormItem>
          </i-col>
          <i-col :xs = "10" :sm = "10" :md = "10" :lg = "10">
            <FormItem label = "Event Name" :prop = "'eventName'"
                      :rules = "{required: true, message: 'Event Name cannot be empty', trigger: 'blur'}">
              <Input v-model = "eventForm.eventName"></Input>
            </FormItem>
          </i-col>
          <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">
            <FormItem label = "City" :prop = "'city'"
                      :rules = "{required: true, message: 'City cannot be empty', trigger: 'blur'}">
              <Input v-model = "eventForm.city"></Input>
            </FormItem>
          </i-col>
          <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">
            <FormItem label = "Country" :prop = "'country'"
                      :rules = "{required: true, message: 'Country cannot be empty', trigger: 'change'}">
              <Select v-model = "eventForm.country" filterable clearable>
                <Option v-for = "item in countries" :value = "item.name" :key = "item.name">{{item.name.trim()}}</Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>

        <Row class="my-3">
          <i-col :xs = "8" :sm = "8" :md = "8" :lg = "8">
            <FormItem label = "Scan Protocols" :prop = "'creationModeIds'">
              <Select multiple filterable style = "width: 86%;" placeholder = "Click to view items">
                <Option v-for = "item in creationModes.values" :value = "item.id" :key = "item.id" disabled>
                  {{ item.type }} ({{item.protocols}})
                </Option>
              </Select>
              <Icon role="button" type = "ios-create-outline" style = "font-size: 25pt"
                    @click.native = "openScanMode"
                    title = "Edit Scan Mode Settings" />
            </FormItem>
          </i-col>
          <i-col :xs = "4" :sm = "4" :md = "4" :lg = "4">
            <FormItem label = "Scan Mode" :prop = "'scanMode'"
                      :rules = "{required: true, message: 'Scan Mode cannot be empty', trigger: 'change'}">
              <Select v-model = "eventForm.scanMode" filterable clearable>
                <Option v-for = "item in scanModeList" :value = "item.value" :key = "item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">
            <FormItem label = "Start Date" :prop = "'startDate'"
                      :rules = "{required: true, message: 'Start Date cannot be empty', trigger: 'blur'}">
              <Input :value = "eventForm.startDate && eventForm.startDate.split('T')[0]"
                    @input = "(val)=>validateDate('startDate', val)" type = "date">
              </Input>
            </FormItem>
          </i-col>
          <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">
            <FormItem label = "End Date" :prop = "'endDate'"
                      :rules = "{required: true, message: 'End Date be empty', trigger: 'blur'}">
              <Input :value = "eventForm.endDate && eventForm.endDate.split('T')[0]"
                    @input = "(val) => validateDate('endDate', val)" type = "date">
              </Input>
            </FormItem>
          </i-col>
        </Row>

        <Row class="my-3">
          <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
            <FormItem label = "Select Companies" :prop = "'companyIds'">
              <Select v-model = "selectedCompany" multiple filterable>
                <Option v-for = "item in companyList" :value = "item.companyId" :key = "item.companyId">
                  {{item.companyName}}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
      </div>
    </Form>

    <Form enctype = "multipart/form-data">
      <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
        <i-col :xs = "4" :sm = "4" :md = "4" :lg = "4">
          <FormItem :prop = "'iconImage'">
            <label v-show = "isIconImage">Icon Image</label>
            <label v-show = "!isIconImage">Icon URL</label>
            <br>
            <i-switch v-model = "isIconImage" id = "iconSwitch" @on-change = "resetIconPreview"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs = "20" :sm = "20" :md = "20" :lg = "20">
          <FormItem :prop = "'logoUrl'">
            <input accept="image/*" name = "file" v-show = "isIconImage" type = "file" id = "iconFile" ref = "iconFile"
                   v-on:change = "iconChange($event.target.files)" />
            <Input v-show = "!isIconImage" v-model = "eventForm.iconUrl"
                   @on-change = "displayIcon($event.target.value); iconImg = null;" />
            <br>
            <table class = "logoBox my-1">
              <tr>
                <td align = "center" style="max-width: 300px;max-height: 200px;">
                  <div class = "image_preview_cont"></div>
                </td>
              </tr>
            </table>
          </FormItem>
        </i-col>
      </i-col>

      <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
        <i-col :xs = "4" :sm = "4" :md = "4" :lg = "4">
          <FormItem :prop = "'bannerImage'">
            <label v-show = "isBannerImage">Banner Image</label>
            <label v-show = "!isBannerImage">Banner URL</label>
            <br>
            <i-switch v-model = "isBannerImage" id = "bannerSwitch" @on-change = "resetBannerPreview"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs = "20" :sm = "20" :md = "20" :lg = "20">
          <FormItem :prop = "'logoUrl'">
            <input accept="image/*" name = "file" v-show = "isBannerImage" type = "file" id = "bannerFile" ref = "bannerFile"
                   v-on:change = "bannerChange($event.target.files)" />
            <Input v-show = "!isBannerImage" v-model = "eventForm.bannerUrl"
                   @on-change = "displayBanner($event.target.value); bannerImg = null;" />
            <br>
            <table class = "logoBox my-1">
              <tr>
                <td align = "center" style="max-width: 300px;max-height: 200px;">
                  <div class = "banner_preview_cont"></div>
                </td>
              </tr>
            </table>
          </FormItem>
        </i-col>
      </i-col>
    </Form>
    <scanModeForm ref = "scanModeForm" :creationModes = "creationModes" @submitModes = "creationModes = $event"></scanModeForm>
    <div slot = "footer" id = "dvFooter">
      <Button class="btn btn-outline-secondary btn-sm" @click="handleReset; showFormModal=false">
        Cancel
      </Button>
      <Button class="submit btn btn-success btn-sm" type = "success" @click = "handleCreate('eventForm')"
              v-if = "action=='add'">
        Create
      </Button>
      <Button class="submit btn btn-success btn-sm" type = "success" v-if = "action=='edit'"
              @click = "handleUpdate('eventForm', eventForm.eventId)">
        Save
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {
    addCreationMode,
    addEvent,
    deleteCreationMode,
    getCreationMode,
    updateCreationMode,
    updateEvent,
    uploadImages
  } from '../../services/Events.service'
  import {getCompanies} from '../../services/Companies.service'
  import {countries} from '../../services/countries'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'
  import moment from 'moment-timezone'
  import scanModeForm from './scanModeForm'

  export default {
    components: {
      scanModeForm
    },
    data() {
      return {
        bannerImg: null,
        iconImg: null,
        fileImg: new FormData(),
        countries: countries,
        companyList: null,
        selectedCompany: null,
        result: null,
        index: 0,
        action: 'Add',
        title: 'ADD Event',
        showFormModal: false,
        eventForm: {
          eventId: null,
          eventName: null,
          startDate: null,
          endDate: null,
          city: null,
          country: null,
          location: null,
          bannerUrl: null,
          bannerImage: null,
          iconUrl: null,
          iconImage: null,
          participantForm: null,
          scanMode: null,
          createdBy: null,
          createdDate: null,
          deleted: false,
          deletionDate: null,
          updatedBy: null,
          updatedDate: null,
          userIds: null,
          leadIds: null,
          formIds: null,
          licenseIds: null,
          companyIds: null,
          participantIds: null,
          creationModeIds: null,
          dashBoardIds: null,
        },
        indeterminate: null,
        checkAll: false,
        ruleValidate: {},
        spinnerShow: true,
        oldIconImage: null,
        oldBannerImage: null,
        isIconImage: false,
        isBannerImage: false,
        //scanModeList: ['NFC', 'None', 'Barcode Code39', 'Encoded QRcode (TechEvent format)']
        scanModeList: [
          {
            label: 'Classic',
            value: 'classic'
          },
          {
            label: 'Fast Scan',
            value: 'fast_scan'
          }
        ],
        selectedCreationMode: null,
        creationModes: {
          id: null,
          eventId: null,
          dateModified: moment().format('YYYY-MM-dd'),
          values: [
            {
              id: 1,
              type: 'Manual',
              protocols: null,
              encoded: false,
              options: null,
              key: null,
            }
          ]
        },
        oldCreationModes: null
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),
      openScanMode () {
        // this.handleResetMode();
        this.$refs.scanModeForm.openModeForm('Scan Mode Settings', 'edit');
        // this.$refs.scanModeForm.setFormValue(this.eventForm.eventId);
      },
      iconChange(fileList) {
        const self = this;
        if (fileList.length === 0) {
          self.eventForm.iconUrl = self.oldIconImage;
          self.iconImg = null;
          document.getElementsByClassName('image_preview_cont')[0].innerHTML = "";
          return;
        }
        // self.iconImg = new FormData();
        self.iconImg = fileList[0];
        var reader = new FileReader(),
          files = fileList[0];

        reader.onload = function (e) {
          self.displayIcon(e.target.result);
        }
        reader.readAsDataURL(files);
      },
      bannerChange(fileList) {
        const self = this;
        if (fileList.length === 0) {
          self.eventForm.bannerUrl = self.oldBannerImage;
          self.bannerImg = null;
          document.getElementsByClassName('banner_preview_cont')[0].innerHTML = "";
          return;
        }
        self.bannerImg = fileList[0];
        var reader = new FileReader(),
          files = fileList[0];

        reader.onload = function (e) {
          self.displayBanner(e.target.result);
        }
        reader.readAsDataURL(files);
      },
      resetBannerPreview(val) {
        this.isBannerImage = val;
        if (this.isBannerImage) {
          document.getElementsByClassName('banner_preview_cont')[0].innerHTML = "";
        } else {
          if (this.eventForm.bannerUrl) {
            this.displayBanner(this.eventForm.bannerUrl);
          }
        }
      },
      resetIconPreview(val) {
        this.isIconImage = val;
        if (this.isIconImage) {
          document.getElementsByClassName('image_preview_cont')[0].innerHTML = "";
        } else {
          if (this.eventForm.iconUrl) {
            this.displayIcon(this.eventForm.iconUrl);
          }
        }
      },
      displayIcon(image) {
        var self = this;
        var img = new Image();
        var container = document.getElementsByClassName('image_preview_cont')[0];
        if (!container) return;
        container.innerHTML = "";
        img.id = 'icon_preview' + container.getElementsByTagName('img').length;
        img.src = image;
        img.style.height = '100%';
        img.style.width = '100%';
        if ((image.match(/.ico/g) || []).length > 0) {

        }
        container.appendChild(img);
      },
      displayBanner(image) {
        var img = new Image();
        var container = document.getElementsByClassName('banner_preview_cont')[0];
        if (!container) return;
        container.innerHTML = "";
        img.id = 'banner_preview' + container.getElementsByTagName('img').length;
        img.src = image;
        img.style.height = '100%';
        img.style.width = '100%';
        container.appendChild(img);
      },

      openEventForm(title, action) {
        this.spinnerShow = true;
        this.handleReset();
        this.showFormModal = true;
        this.title = title;
        this.action = action;
        this.isIconImage = false;
        this.isBannerImage = false;

        if (action == 'add') {
          getCompanies(false).then(a => {
            this.companyList = [];
            this.selectedCompany = [];
            a.data.map(item => {
              this.companyList.push(item);
            });
          });
          this.eventForm.deleted = false;
          this.eventForm.country = 'France';
        }
        this.spinnerShow = false;
      },
      setFormValue(params, index, selectedCompany, companyList) {
        const self = this;
        self.spinnerShow = true;
        self.companyList = [];
        self.selectedCompany = [];
        self.selectedCompany = selectedCompany;
        self.companyList = companyList;
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        self.eventForm = data;
        self.oldCreationModes = [];

        this.oldIconImage = this.eventForm.iconUrl;
        this.oldBannerImage = this.eventForm.bannerUrl;

        if (this.eventForm.iconUrl) {
          this.displayIcon(this.eventForm.iconUrl);
        } else {
          document.getElementsByClassName('image_preview_cont')[0].innerHTML = "";
        }
        if (this.eventForm.bannerUrl) {
          this.displayBanner(this.eventForm.bannerUrl);
        } else {
          document.getElementsByClassName('banner_preview_cont')[0].innerHTML = "";
        }

        if (self.eventForm.location) {
          if (self.eventForm.location.indexOf(',') > -1) {
            self.eventForm.city = self.eventForm.location.split(',')[0].trim();
            self.eventForm.country = self.eventForm.location.split(',')[1].trim();
          } else {
            self.eventForm.city = self.eventForm.location;
            self.eventForm.country = null;
          }
        } else {
          self.eventForm.city = null;
          self.eventForm.country = null;
        }
        getCreationMode(params.eventId).then(cMode => {
          if (cMode.data) {
            self.creationModes = [];
            self.creationModes = cMode.data;
            self.oldCreationModes = cMode.data;
          }
          self.spinnerShow = false;
        });
      },
      handleCreate(name) {
        const self = this;
        self.$refs[name].validate((valid) => {
          if (valid) {
            self.spinnerShow = true;
            const data = Object.assign({}, self.eventForm);
            data['eventId'] = 0;
            data['eventName'] = data.eventName;
            data['location'] = data.city.trim() + ',' + data.country.trim();
            data['startDate'] = data.startDate;
            data['endDate'] = data.endDate;
            data['bannerUrl'] = data.bannerUrl;
            data['bannerImage'] = data.bannerImage;
            data['iconUrl'] = data.iconUrl;
            data['iconImage'] = data.iconImage;
            data['participantForm'] = data.participantForm;
            data['scanMode'] = data.scanMode;
            data['createdBy'] = data.createdBy;
            data['createdDate'] = data.createdDate;
            data['deleted'] = data.deleted;
            data['deletionDate'] = data.deletionDate;
            data['updatedBy'] = data.updatedBy;
            data['updatedDate'] = data.updatedDate;
            data['userIds'] = data.userIds;
            data['leadIds'] = data.leadIds;
            data['formIds'] = data.formIds;
            data['licenseIds'] = data.licenseIds;
            data['companyIds'] = self.selectedCompany;
            data['participantIds'] = data.participantIds;
            data['creationModeIds'] = data.creationModeIds;
            data['dashBoardIds'] = data.dashBoardIds;

            self.fileImg = new FormData();
            if (self.iconImg) {
              self.fileImg.append(self.iconImg.name, self.iconImg, 'EventIcon');
            }
            if (self.bannerImg) {
              self.fileImg.append(self.bannerImg.name, self.bannerImg, 'EventBanner');
            }
            addEvent(data)
              .then(response => {
                  self.creationModes.eventId = response.data.eventId;
                  self.creationModes.creationModeId = 0;
                  addCreationMode(self.creationModes)
                    .then(ins => {
                    })
                    .catch(error => {
                      self.spinnerShow = false;
                      self.$Message.error('Failed updating Event');
                    });

                if (self.fileImg != null) {
                  uploadImages(response.data.eventId, self.fileImg).then(dataResponse => {
                    data.eventId = response.data.eventId;
                    data.iconUrl = dataResponse.data.iconPath;
                    data.bannerUrl = dataResponse.data.bannerPath;

                    updateEvent(response.data.eventId, data).then(dataResponse => {
                      self.showFormModal = false;
                      data['eventId'] = response.data.eventId;
                      self.$emit('addEvent', data);
                      self.$Message.success('Event successfully added!');
                      bus.$emit('changeForm', localStorage.getItem('selected_event'));
                      bus.$emit('reloadAdminData');
                      bus.$emit('GetCompaniesEvents');
                      self.spinnerShow = false;
                    }).catch(error => {
                      self.spinnerShow = false;
                      self.$Message.error('Failed updating Event Icon');
                    })
                  }).catch(error => {
                    this.$Message.error('Failed uploading icon');
                  });
                } else {
                  self.showFormModal = false;
                  data['eventId'] = response.data.eventId;
                  self.$emit('addEvent', data);
                  self.$Message.success('Event successfully added!');
                  bus.$emit('changeForm', localStorage.getItem('selected_event'));
                  bus.$emit('reloadAdminData');
                  bus.$emit('GetCompaniesEvents');
                  self.spinnerShow = false;
                }
              })
              .catch(error => {
                self.showFormModal = false;
                self.spinnerShow = false;
                console.log(error.response);
                if (error.response.request.responseText) {
                  let errResponse = JSON.parse(error.response.request.responseText)
                  Object.keys(errResponse).map(key => {
                    errResponse[key].map(errMsg => {
                      self.$Message.error(errMsg);
                    })
                  })
                } else {
                  self.$Message.error('Failed adding Event');
                }
              });
          }
        })
      },
      handleUpdate(name, id) {
        const self = this;

        self.fileImg = new FormData();
        if (self.iconImg) {
          self.fileImg.append(self.iconImg.name, self.iconImg, 'EventIcon');
        } else if (!self.eventForm.iconUrl) {
          self.eventForm.iconUrl = self.oldIconImage;
        }
        if (self.bannerImg) {
          self.fileImg.append(self.bannerImg.name, self.bannerImg, 'EventBanner');
        } else if (!self.eventForm.bannerUrl) {
          self.eventForm.bannerUrl = self.oldBannerImage;
        }
        this.$refs['eventForm'].validate((valid) => {
          let startDateSuccess = false;
          let endDateSuccess = false;
          if (self.eventForm.startDate) {
            startDateSuccess = true;
          }
          if (self.eventForm.endDate) {
            endDateSuccess = true;
          }
          if (startDateSuccess == false) {
            self.$Message.error('Start Date is required...');
          } else if (endDateSuccess == false) {
            self.$Message.error('End Date is required...');
          } else {
            if (valid) {
              self.eventForm.location = self.eventForm.city.trim() + ', ' + self.eventForm.country.trim();

              uploadImages(id, self.fileImg).then(response => {
                if (response.data != null) {
                  if (response.data.iconPath != null) {
                    self.eventForm.iconUrl = response.data.iconPath;
                  }
                  if (response.data.bannerPath != null) {
                    self.eventForm.bannerUrl = response.data.bannerPath;
                  }
                }
                const data = Object.assign({}, self.eventForm);
                data['companyIds'] = self.selectedCompany;
                self.spinnerShow = true;

                updateEvent(id, data).then(response => {
                    if (self.oldCreationModes !== self.creationModes) {
                      self.creationModes.eventId = id;
                      updateCreationMode(id, self.creationModes)
                        .then(upd => {
                        })
                        .catch(error => {
                          self.spinnerShow = false;
                          self.$Message.error('Failed updating Event');
                        });
                    }

                  self.$emit('updateEvent', id, data);
                  self.$Message.success('Event successfully updated!');
                  bus.$emit('changeForm', localStorage.getItem('selected_event'));
                  bus.$emit('reloadAdminData');
                  bus.$emit('GetCompaniesEvents');
                  self.showFormModal = false;
                  self.spinnerShow = false;
                }).catch(error => {
                  this.$Message.error('Failed updating Event');
                });
              }).catch(error => {
                this.$Message.error('Failed uploading icon');
              });
            }
          }
        });

      },
      handleReset() {
        this.$refs['eventForm'].resetFields();
        let self = this;
        Object.keys(this.eventForm).forEach(function (key, i) {
          self.eventForm[key] = '';
        });
        this.creationModes = {
          creationModeId: null,
          eventId: null,
          dateModified: moment().format('YYYY-MM-dd'),
          values: [
            {
              id: 1,
              type: 'Manual',
              protocols: null,
              encoded: false,
              options: null,
              key: null,
            }
          ]
        };
        document.getElementById('iconFile').value = "";
        document.getElementById('bannerFile').value = "";
        self.isIconImage = false;
        self.isBannerImage = false;
        self.iconImg = null;
        self.bannerImg = null;
        self.fileImg = null;
        document.getElementsByClassName('image_preview_cont')[0].innerHTML = "";
        document.getElementsByClassName('banner_preview_cont')[0].innerHTML = "";
        document.getElementById('iconFile').value = "";
      },
      validateDate(name, val) {
        let valid1 = false;
        let valid2 = false;

        // regular expression to match required date format
        let regExp1 = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/; //MM/dd/yyyy
        let regExp2 = /^(\d{4})\-(\d{1,2})\-(\d{1,2})$/; //yyyy-mm-dd

        valid1 = val.match(regExp1);
        valid2 = val.match(regExp2);

        if (name == 'startDate') {
          if (valid1 || valid2) {
            this.eventForm.startDate = val;
          } else {
            this.eventForm.startDate = null;
          }
        }

        if (name == 'endDate') {
          if (valid1 || valid2) {
            this.eventForm.endDate = val;
          } else {
            this.eventForm.endDate = null;
          }
        }
      },
      deletedEvent(val) {
        this.eventForm.deleted = val;
      }
    }
  }
</script>

<style scoped>
  .logoBox {
    display: block;
    width: 100%;
    border: 0.5px dashed #000;
    border-radius: 5px;
  }

  .full-input {
    display: inline-block;
    width: 100%;
    padding: 3px;
    border: 1px solid #f8f8f9;
    border-radius: 4px;
    width: 100%;
  }

  .input-answer {
    display: block;
    width: 100%;
    outline: none;
    border: none;
    line-height: 1.2em;
    font-size: 14pt;
  }

  .label-answer {
    text-align: left;
    display: block;
    font: normal 12px italic;
    color: #000;
    opacity: 0.5
  }

  #dvFooter {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/eventForm.vue